import React from 'react';
import { Icon } from 'react-icons-kit';
import { caretRight } from 'react-icons-kit/fa';
// eslint-disable-next-line no-unused-vars
import tw, { styled } from 'twin.macro';
import { SectionTitle } from './ui-elements';

const TripCardTitle = tw(SectionTitle)`md:text-center md:text-2xl`;
const TripCardContainer = styled.div`
  ${tw`bg-primary-200 p-6 rounded`};
`;
const PriceContainer = styled.div`
  ${tw`font-heading text-lg italic text-center text-primary-500 font-bold pt-8 mb-0`};
`;

type Pricing = {
  tripName: string;
  tripPrice: number;
  _key: string;
};

type TripCardProps = {
  tripDuration: number;
  excluded: string[];
  included: string[];
  pricing: Pricing[];
  title: string;
};

const TripCard = ({
  title,
  tripDuration,
  included,
  excluded,
  pricing,
}: TripCardProps) => (
  <TripCardContainer>
    <TripCardTitle>{title}</TripCardTitle>
    <p tw="text-center">
      <strong tw="font-bold">{tripDuration}</strong> hours on the water
    </p>
    <SectionTitle>Includes:</SectionTitle>
    {included && (
      <ul>
        {included.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    )}
    <SectionTitle tw="pt-4">Not Included:</SectionTitle>
    {excluded && (
      <ul>
        {excluded.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    )}
    <PriceContainer>
      {pricing &&
        pricing.map((item, key, arr) => {
          let notLast = true;
          if (Object.is(arr.length - 1, key)) {
            notLast = false;
          }
          return (
            <div tw="inline-block mt-2" key={item._key}>
              ${item.tripPrice} {item.tripName}
              {notLast && (
                <span tw="px-1">
                  <Icon icon={caretRight} size={24} />
                </span>
              )}
            </div>
          );
        })}
    </PriceContainer>
  </TripCardContainer>
);

export default TripCard;
